/** Token autocomplete DTO (Jupiter Token API v2, slimmed for the UI). */
export interface TokenSuggestion {
  mint: string;
  symbol: string;
  name: string;
  icon: string | null;
  verified: boolean;
  mcap: number | null;
  liquidity: number | null;
  holderCount: number | null;
}

/** True when input looks like a pasted Solana address, not a symbol search. */
export function looksLikeMint(input: string): boolean {
  const s = input.trim();
  if (s.length < 32 || s.length > 44) return false;
  return /^[1-9A-HJ-NP-Za-km-z]+$/.test(s);
}

export function fmtCompactUsd(n: number | null | undefined): string | null {
  if (n == null || !Number.isFinite(n) || n <= 0) return null;
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(0)}k`;
  return `$${Math.round(n)}`;
}
